import { parseValidJSON } from './parseValidJSON';
//todo: verify if gtag.js approach should be used
export const gtagConsentUpdate = () => {
  const gtag = window.gtag;
  //function gtag() { dataLayer.push(arguments); }

  gtag('consent', 'update', {
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    ad_storage: 'granted',
    analytics_storage: 'granted',
  });
};

export const gtagConsentInit = () => {
  const gtag = window.gtag;
  gtag('consent', 'default', {
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
  });
};

export const gtagConsentInitLiteral = `
gtag('consent', 'default', {
   'ad_user_data': 'denied',
   'ad_personalization': 'denied',
   'ad_storage': 'denied',
   'analytics_storage': 'denied',
   'wait_for_update': 500,
 });
`;

export const injectPreGTMScript = () => {
  const preGTMScript = document.createElement('script');

  const lsTokenClaims = parseValidJSON(localStorage.getItem('tokenClaims'));
  const userId = lsTokenClaims?.sub;
  const userIdLiteral = userId ? `"${userId}"` : 'undefined';

  preGTMScript.innerHTML = `
    ;window.dataLayer = window.dataLayer || [];
    (function() { 
      const userId = ${userIdLiteral};
      if (userId) {
        window.dataLayer.push({
          user_id: userId,
        });
      }
    })();
  `;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(preGTMScript, firstScript);
};

/**
 * Initialize GTM script
 * We must wait for consent before loading GTM
 * https://developers.google.com/tag-platform/security/guides/consent?consentmode=basic#set_up_consent_mode
 */
export const initGTMScript = () => {
  const initGTMScript = document.createElement('script');

  initGTMScript.innerHTML = `
    ;window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    ${gtagConsentInitLiteral}
    dataLayer.push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
  `;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(initGTMScript, firstScript);
};

export const injectGTMScript = () => {
  injectPreGTMScript();
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.REACT_APP_GTM_ID}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.after(gtmScript);
};

const injectPreGTAGScript = () => {
  const preGTAGGA4Script = document.createElement('script');
  preGTAGGA4Script.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    ${gtagConsentInitLiteral}
    gtag('js', new Date());
    gtag('config', '${process.env.REACT_APP_GA4_ID}');
  `;
};

export const injectGTAGScript = () => {
  injectPreGTAGScript();
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA4_ID}`;
  script.async = true;
  document.querySelector('body').appendChild(script);
};

export const injectGTMScriptLegacy = () => {
  injectPreGTMScript();
  const GTM_Script = document.createElement('script');
  const noscript = document.createElement('noscript');

  GTM_Script.innerHTML = `          
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${process.env.REACT_APP_GTM_ID}');`;

  noscript.innerHTML = `
  <iframe src="https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.head.insertBefore(GTM_Script, document.head.childNodes[1]);
  document.body.insertBefore(noscript, document.body.childNodes[1]);
};
